import React from 'react';
import MuiListItemIcon, { ListItemIconProps } from '@mui/material/ListItemIcon';

export type { ListItemIconProps };

export const ListItemIcon: React.FC<ListItemIconProps> = (props) => {
  return <MuiListItemIcon {...props} />;
};
